<template>
  <base-floating-card @close="close">
    <div id="delete-event-card">
      <delete-event-art class="art" />
      <div id="heading-and-buttons">
        <h5 id="delete-event-heading">Delete this event?</h5>
        <div id="delete-event-buttons">
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'x'"
            @click="close"
          />
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'checkmark'"
            @click="confirm"
          />
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import RoundButtonWithIcon from "../../RoundButtonWithIcon.vue";
import DeleteEventArt from "../../Illustrations/DeleteEvent.vue";

export default {
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    contactName() {
      if (this.contact) {
        return `${this.contact.given_name} ${this.contact.family_name}`;
      } else {
        return "this contact";
      }
    },
  },
  methods: {
    close() {
      if (!this.processing) {
        this.$emit("close");
      }
    },
    async confirm() {
      this.processing = true;
      let payload = {
        event: this.event,
      };
      await this.$store.dispatch("deleteEvent", payload);
      this.processing = false;
      this.$router.push("/");
      this.close();
    },
  },
  created() {},
  components: {
    BaseFloatingCard,
    RoundButtonWithIcon,
    DeleteEventArt,
  },
  emits: ["close"],
  props: ["contact", "event"],
};
</script>
<style scoped>
@media screen {
  #delete-event-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 25px;
  }

  .art {
    min-width: 75px;
    min-height: 75px;
  }

  #heading-and-buttons {
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #delete-event-buttons {
    display: flex;
    width: 100px;
    justify-content: space-between;
  }
  @media (min-width: 800px) {
    #delete-event-card {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 50px;
      width: 400px;
      height: 125px;
    }

    .art {
      margin-right: 70px;
    }

    #heading-and-buttons {
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    #delete-event-buttons {
      display: flex;
      width: 100px;
      justify-content: space-between;
    }
  }
}
</style>
